import initModal from './initializers/Modal.js'
import initUser from './initializers/User.js'
import initMacro2026Registration from './initializers/Macro2026Registration.js'

const initApplication = () => {
  initModal()
  initUser()
  initMacro2026Registration()
}

export default initApplication
